import { render } from "./Error404.vue?vue&type=template&id=4d3050fa&scoped=true"
import script from "./Error404.vue?vue&type=script&lang=js"
export * from "./Error404.vue?vue&type=script&lang=js"

import "./Error404.vue?vue&type=style&index=0&id=4d3050fa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d3050fa"

export default script